"use client"
import React from 'react';
import {Column} from "@/core/general/column.component";
import {ContainerComponent} from "@/core/general/container/container.component";
import {Row} from "@/core/general/row.component";
import {useTranslations} from "use-intl";
import {useRouter} from "next/navigation";

export default function NotFound() {
  const t = useTranslations();
  const router = useRouter();
  return (
    <ContainerComponent>
      <Column className="totalCenter top30">
        <Row className="w-3/4 totalCenter">
          <div className="w-1/4 lg:w-1/6 m-2">
            <div className="text-bold borderButton text-center" onClick={() => window.location.reload()}>
              {t('retry')}
            </div>
          </div>
          <div className="w-1/4 lg:w-1/6 m-2">
            <div className="text-bold borderButton text-center" onClick={() => router.back()}>
              {t('return')}
            </div>
          </div>
        </Row>
        <div className="text-bold fs-4 mt-2">{t('pageInProgressMessage')}</div>
      </Column>
    </ContainerComponent>
  );
}
